import styled from 'styled-components';

import {
  mediaSmallOnly,
  mediaConfinedNavlessOnly,
} from '@xing-com/layout-tokens';
import { spaceL } from '@xing-com/tokens';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  gap: ${spaceL};

  @media ${mediaSmallOnly} {
    grid-template-columns: 1fr;
  }
  @media ${mediaConfinedNavlessOnly} {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1024px) and (max-width: 1268px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1269px) and (max-width: 1655px) {
    grid-template-columns: repeat(6, 1fr);
  }
  @media (min-width: 1655px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;
